import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { TicketDetailsSchema } from "../../Schemas/Ticket";

interface TicketDetailsUrlParams {
  ticketNumber: string;
}

export interface TicketDetailsResponseBody extends IResponseBody {
  data: {
    ticket: TicketDetailsSchema;
  };
}

export interface TicketNoteCreateRequestBody {
  description: string;
  image?: File;
}

export class TicketNoteCreateRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(ticketDetailsUrlParams: TicketDetailsUrlParams) {
    return `/admin/tickets/${ticketDetailsUrlParams.ticketNumber}/answer`;
  }

  private getClosePath(ticketDetailsUrlParams: TicketDetailsUrlParams) {
    return `/admin/tickets/${ticketDetailsUrlParams.ticketNumber}/close`;
  }
  private getInProcessPath(ticketDetailsUrlParams: TicketDetailsUrlParams) {
    return `/admin/tickets/${ticketDetailsUrlParams.ticketNumber}/in-progress`;
  }

  async send(
    ticketDetailsUrlParams: TicketDetailsUrlParams,
    ticketCreateBody: TicketNoteCreateRequestBody
  ): Promise<TicketDetailsResponseBody> {
    console.log(ticketCreateBody);
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(ticketDetailsUrlParams),
        ticketCreateBody
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async sendFormData(
    ticketDetailsUrlParams: TicketDetailsUrlParams,
    ticketCreateFormData: FormData
  ): Promise<TicketDetailsResponseBody> {
    console.log(ticketCreateFormData);
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(ticketDetailsUrlParams),
        ticketCreateFormData
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async close(
    ticketDetailsUrlParams: TicketDetailsUrlParams
  ): Promise<TicketDetailsResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getClosePath(ticketDetailsUrlParams)
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async inProcess(
    ticketDetailsUrlParams: TicketDetailsUrlParams
  ): Promise<TicketDetailsResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getInProcessPath(ticketDetailsUrlParams)
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
